import { languages, findSupportedLanguageTag } from '@logto/language-kit';
import { z } from 'zod';
import en from './locales/en/index.js';
export const builtInLanguages = ['en'];
export const builtInLanguageOptions = builtInLanguages.map((languageTag) => ({
    value: languageTag,
    title: languages[languageTag],
}));
export const builtInLanguageTagGuard = z.enum(builtInLanguages);
const resource = {
    en,
};
export const getDefaultLanguageTag = (language) => builtInLanguageTagGuard.parse(findSupportedLanguageTag(language ? [language] : [], builtInLanguages, 'en'));
export const isBuiltInLanguageTag = (language) => builtInLanguageTagGuard.safeParse(language).success;
export default resource;
